import React from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '@mui/material';

import { Breadcrumbs } from 'src/components/common/breadcrumbs/Breadcrumbs';
import { IBreadcrumbItem } from 'src/components/common/types/breadcrumbsTypes';

import AppLayout from './AppLayout';

interface IPageWithLayoutProps {
	children: React.ReactNode;
	breadcrumbs?: IBreadcrumbItem[];
	headerCenterContent?: React.ReactNode;
	headerRightContent?: React.ReactNode;
}

const PageWithLayout: React.FC<IPageWithLayoutProps> = ({
	children,
	breadcrumbs,
	headerCenterContent,
	headerRightContent,
}) => {
	const location = useLocation();
	const isSignInPage = location.pathname === '/signin';

	if (isSignInPage) {
		return <>{children}</>;
	}

	return (
		<AppLayout>
			<Box
				display='flex'
				justifyContent='space-between'
				alignItems='center'
			>
				<Box flex={1}>
					{breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
				</Box>
				{headerCenterContent}
				{headerRightContent}
			</Box>

			{children}
		</AppLayout>
	);
};

export default PageWithLayout;
